import { createSelector } from 'reselect';

export const getServerRequests = state => state.serverRequests;

export const getIsServerBusy = createSelector([getServerRequests], server => server.isServerBusy);
